export { default } from './SpecialistFullContainer';
